import { render, staticRenderFns } from "./card-header.vue?vue&type=template&id=99adf9be&scoped=true&"
import script from "./card-header.vue?vue&type=script&lang=ts&"
export * from "./card-header.vue?vue&type=script&lang=ts&"
import style0 from "./card-header.vue?vue&type=style&index=0&id=99adf9be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99adf9be",
  null
  
)

export default component.exports